import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormView, DialogModal } from ".";
import { showDialog } from "../../appRedux/actions/common";
import { clearSubscriptionInfo } from "../../appRedux/actions/subscriptions";

function AddInfo() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const { dialog } = useSelector((state) => ({
    dialog: state.common.dialog,
  }));

  useEffect(() => {
    if (!dialog) setOpen(dialog);
  }, [dialog]);

  return (
    <Fragment>
      <button
        className="btn btn-primary animate-btn"
        style={{
          borderRadius: "6px",
          padding: "10px 20px",
          fontWeight: 500,
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)"
        }}
        onClick={() => {
          dispatch(clearSubscriptionInfo());
          setOpen(true);
          dispatch(showDialog({ title: "Add Subscription", size: "lg", id: "01" }));
        }}
      >
        <i className="fa fa-plus mr-1" /> Add Subscription
      </button>
      {open && (
        <DialogModal
          infoId="01"
          bodyView={<FormView isUpdate={false} />}
        />
      )}
    </Fragment>
  );
}

export default AddInfo;
